export default "__VITE_ASSET__5bde34c4__"